import { getter, clone } from '@progress/kendo-react-common';
import { parseRule, expand } from '@progress/kendo-recurrence';
import { ZonedDate } from '@progress/kendo-date-math';
import { toUTCDateTime, setField, isMaster } from '../utils';
/** @hidden */
export var toOccurrences = function (data, _a) {
    var dateRange = _a.dateRange, fields = _a.fields, timezone = _a.timezone;
    var result = data
        .map(readItem(fields))
        .reduce(occurrenceReducer(dateRange, timezone, fields), [])
        .filter(function (occurrence) { return !isMaster(occurrence.dataItem, fields); });
    return result;
};
var readItem = function (fields) { return function (dataItem) {
    var result = {
        uid: getter(fields.id || 'id')(dataItem),
        start: getter(fields.start || 'start')(dataItem),
        startTimezone: getter(fields.startTimezone || 'startTimezone')(dataItem),
        originalStart: getter(fields.originalStart || 'originalStart')(dataItem),
        end: getter(fields.end || 'end')(dataItem),
        endTimezone: getter(fields.endTimezone || 'endTimezone')(dataItem),
        isAllDay: getter(fields.isAllDay || 'isAllDay')(dataItem),
        title: getter(fields.title || 'title')(dataItem),
        description: getter(fields.description || 'description')(dataItem),
        occurrenceId: getter('occurrenceId')(dataItem),
        recurrenceRule: getter(fields.recurrenceRule || 'recurrenceRule')(dataItem),
        recurrenceExceptions: getter(fields.recurrenceExceptions || 'recurrenceExceptions')(dataItem),
        recurrenceId: getter(fields.recurrenceId || 'recurrenceId')(dataItem),
        dataItem: clone(dataItem)
    };
    return result;
}; };
var occurrenceReducer = function (dateRange, timezone, fields) { return function (acc, current) {
    return acc.concat(((Boolean(current.recurrenceRule)
        && Boolean(current.recurrenceId === null || current.recurrenceId === undefined)
        && isMaster(current.dataItem, fields))
        ? occurrences(current, { dateRange: dateRange, timezone: timezone, fields: fields }).slice() : [current]));
}; };
var occurrences = function (item, _a) {
    var dateRange = _a.dateRange, timezone = _a.timezone, fields = _a.fields;
    var rrule = item.recurrenceRule;
    var rule = parseRule({ recurrenceRule: rrule });
    // changed as for display purposes timezone of the scheduler is the correct one
    if (!rule.start) {
        rule.start = ZonedDate.fromLocalDate(item.start, timezone);
    }
    if (!rule.end) {
        rule.end = ZonedDate.fromLocalDate(item.end, timezone);
    }
    var exceptionRule = item.recurrenceExceptions;
    if (exceptionRule) {
        rule.exceptionDates = exceptionRule
            .map(function (exDate) {
            return ZonedDate.fromLocalDate(exDate, timezone);
        });
    }
    var utcRangeStart = toUTCDateTime(dateRange.start);
    var utcRangeEnd = toUTCDateTime(dateRange.end);
    var series = expand(rule, {
        rangeStart: ZonedDate.fromUTCDate(utcRangeStart, timezone),
        rangeEnd: ZonedDate.fromUTCDate(utcRangeEnd, timezone)
    });
    if (!series.events.length) {
        return [];
    }
    var expanded = series.events.map(function (occurrence, idx) {
        var occurrenceItem = clone(item);
        var occurrenceDataItem = clone(item.dataItem);
        occurrenceItem.recurrenceId = occurrenceItem.uid;
        setField(occurrenceDataItem, fields.recurrenceId, item.uid);
        occurrenceItem.originalStart = occurrence.start.toLocalDate();
        setField(occurrenceDataItem, fields.originalStart, occurrence.start.toLocalDate());
        occurrenceItem.start = occurrence.start.toLocalDate();
        setField(occurrenceDataItem, fields.start, occurrence.start.toLocalDate());
        occurrenceItem.end = occurrence.end.toLocalDate();
        setField(occurrenceDataItem, fields.end, occurrence.end.toLocalDate());
        occurrenceItem.occurrenceId = String(idx);
        setField(occurrenceDataItem, 'occurrenceId', String(idx));
        occurrenceItem.dataItem = occurrenceDataItem;
        return occurrenceItem;
    });
    return expanded;
};
//# sourceMappingURL=occurrenceService.js.map